import { z } from 'zod';

import axiosWithAuth from '@/lib/axios';
import type { OutsourcedVendor } from '@/types/database/outsourcedVendor';
import { outsourcedVendorSchema } from '@/types/database/outsourcedVendor';

const OUTSOURCED_VENDORS_API = '/ezcon/api/outsourcedVendors';

export const getOutsourcedVendors = async () => {
  const { data } = await axiosWithAuth.get(OUTSOURCED_VENDORS_API);
  const validData = z.array(outsourcedVendorSchema).parse(data);
  return validData;
};

export const createOutsourcedVendor = async (
  outsourcedVendor: Pick<OutsourcedVendor, 'name' | 'phone' | 'contactPerson'>
) => {
  const { data } = await axiosWithAuth.post(
    OUTSOURCED_VENDORS_API,
    outsourcedVendor
  );
  return data;
};

export const updateOutsourcedVendor = async (
  outsourcedVendor: OutsourcedVendor
) => {
  const { data } = await axiosWithAuth.patch(
    `${OUTSOURCED_VENDORS_API}/${outsourcedVendor._id}`,
    outsourcedVendor
  );
  return data;
};

export const deleteOutsourcedVendor = async (outsourcedVendorId: string) => {
  const { data } = await axiosWithAuth.delete(
    `${OUTSOURCED_VENDORS_API}/${outsourcedVendorId}`
  );
  return data;
};
